import React from "react";
import MuiAppBar from '@material-ui/core/AppBar';

export default function AppBar(props) {
  const { children, ...rest } = props;
  return (<MuiAppBar {...rest}>
    {children}
  </MuiAppBar>)
}   
